var _circle, _path, _path2, _circle2, _circle3, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#F2FFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.913 21.994-2.13-.528c.424-.664.903-2.068 1.997-2.446.61-.21 1.613-.29 2.577-.252 1.742.07 2.042.168 3.148.638 1.207.514 1.793 1.695 2.5 2.596h-8.029a.26.26 0 0 1-.063-.008z",
    fill: "#31B59F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.278 27.94h4.363m-11.71.124-1.244-.08a.55.55 0 0 1-.514-.508l-.16-2.107V22.91c0-.524.405-.959.928-.996l1.376-.099c.365-.026.702-.208.924-.5l1.586-2.086a3.076 3.076 0 0 1 1.657-1.11l.686-.183a10.778 10.778 0 0 1 4.435-.233v0l.471.073a6.12 6.12 0 0 1 4.104 2.572l.895 1.297a.255.255 0 0 0 .202.11l2.715.083a3.01 3.01 0 0 1 2.916 3.087l-.071 2.748a.32.32 0 0 1-.32.312h-1.553",
    stroke: "#35404A",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.618,
    cy: 28.125,
    r: 2.289,
    stroke: "#35404A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.292,
    cy: 28.125,
    r: 2.289,
    stroke: "#35404A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m30.215 21.767-7.99.235c-1.532-.1-2.82-.407-3.104-.507M23.174 19.033l.772 2.715",
    stroke: "#35404A",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.617,
    cy: 28.125,
    rx: 0.985,
    ry: 0.984,
    fill: "#31B59F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.292,
    cy: 28.125,
    rx: 0.985,
    ry: 0.984,
    fill: "#31B59F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips);
export default __webpack_public_path__ + "static/media/trips.a93d24c30d2acc8cfdef9fe149345731.svg";
export { ForwardRef as ReactComponent };